import React, {useState, useEffect} from 'react'
import Card from '../../../../../components/Card'
import TextInput from '../../../../../components/TextInput'
import Radio from '../../../../../components/Radio'
import styles from './rewards.module.sass'
import RewardTableLayout from '../../../../../components/EngageComponents/PlayersComponent/rewardHistory'
import { useParams } from 'react-router-dom';
import { getPlayerDetailAction } from '../../../../../redux/action/engage/Players/PlayersAction';
import Dropdown from '../../../../../components/Dropdown'
import { useDispatch, useSelector } from 'react-redux';
import {ReactComponent as Previous} from '../../../../../media/images/icons/previous.svg'
import {ReactComponent as Next} from '../../../../../media/images/icons/next.svg'
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';

const Profile = ({activeIndex}) => {

  const {appid} = useParams()
  const {id} = useParams()
  const dispatch = useDispatch()

  const [page, setPage] = useState(1)
  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(10)

  const getPlayerDetails = async() => {
      let playerDetail = {
          entities : {
              value : 'rewards',
              offset: ((page-1)*limit),
              limit: limit
          },
          projectId : appid,
          ids : [id]
      }
      await dispatch(getPlayerDetailAction(playerDetail, activeIndex))
  }

  const onPrevious = () => {
    setPage(prevPage => prevPage - 1)
  }

  const onNext = () => {
    setPage(nextPage => nextPage + 1)
  }

  useEffect(()=>{
    getPlayerDetails()
  }, [activeIndex, page])

  const playerRewards = useSelector((state) => {
      return state.players.rewards
  })

  let totalCount = useSelector((state) => {
    return state.players.totalRewardCount
  })

  const handlePageChange = (event, value)  => {
    setPage(value)
  }

  return (
    <>
        <Card title="Reward History" classTitle="title-purple" head={
          <>
            {/* <div className={styles.dropDown}>
                <Dropdown placeholder='All' />
            </div> */}
          </>
        }>
          <div className={styles.overview}>
            <div className={styles.group}>
              {playerRewards && playerRewards.length > 0 ?
                <>
                  <RewardTableLayout items={playerRewards} />
                  <div className={styles.pagination}>
                      {/* <div className={styles.icons}>
                        <button disabled={page <= 1 ? true : false}>
                          <Previous className={styles.previous} disabled={true} onClick={onPrevious}/>
                        </button>
                        <button disabled={playerRewards.length < 10 ? true : false}>
                          <Next className={styles.next} onClick={onNext}/>
                        </button>
                      </div> */}
                      <Stack spacing={2}>
                      <Pagination renderItem={(item) => (
                        <PaginationItem
                            {...item}
                            sx={{
                              '&.MuiPaginationItem-root': {
                                minWidth: '28px',
                                height: '28px',
                                fontSize: '12px'
                              },
                              '&.Mui-selected': {
                                color: 'rgb(255, 255, 255)',
                                fontWeight : 'bold',
                                border : '1px solid rgb(42, 133, 255)',
                                background : 'rgba(42, 133, 255)'
                              },
                              '&.MuiPaginationItem-page.Mui-selected:hover' : {
                                color: 'rgb(255, 255, 255)',
                                fontWeight : 'bold',
                                border : '1px solid rgb(42, 133, 255)',
                                background : 'rgba(42, 133, 255)'
                              }
                            }}
                        />
                      )} siblingCount={1} count={Math.ceil(totalCount/limit)} color="primary" onChange={handlePageChange} />
                    </Stack>
                  </div>
                </>
              : <div className={styles.warning}>No Data Available</div>}
            </div>
          </div>
        </Card>
    </>
  )
}

export default Profile